import { type ReactNode } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import PageI18nProvider from './PageI18nProvider';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <PageI18nProvider>
      <div className="min-h-screen flex flex-col bg-dark-bg">
        <Navbar />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </PageI18nProvider>
  );
}
